import { create } from 'apisauce';
import store from 'containers/store';
import * as actions from 'containers/App/actions';
import { getAuthToken } from 'utils/cookies';

const token = getAuthToken();


const streamDownload = ({ weddingId, orgId, params }) => {
  return new Promise((resolve, reject) => {
    const input = {
      client_offset: (new Date().getTimezoneOffset()),
      download_type: weddingId ? 'wedding.note' :
        orgId ? 'organization.note_template' : null,
      params,
    };
    const api = create({
      baseURL: `${process.env.REACT_APP_AP_URL}`,
      headers: {
        'content-type': 'application/json, text/plain, */*',
        'X-Requested-With': 'XMLHttpRequest',
        'Authorization': `Bearer ${token}`,
      },
    });

    const url = weddingId ? `/api/wedding/${weddingId}/downloads`
      : `/api/organization/${orgId}/downloads`;

    try {
      api
        .post(url, input)
        .then((response) => {
          if (response.status === 401) {
            if (store) {
              store.dispatch(actions.pushAuthError(response.data?.signin_url ?? '/signin'));
              resolve(response);
            }
          }
          poll(response, api, input, weddingId, orgId)
            .then((downloadResponse) => {
              resolve(downloadResponse);
            })
            .catch((error) => {
              return reject(error);
            });
        });
    } catch (error) {
      return Promise.reject(error);
    }
  });
};

const poll = (response, api, input, weddingId, orgId) => {
  const url = weddingId ? `/api/wedding/${weddingId}/note/download/${response.data.token}`
    : `/api/organization/${orgId}/wedding_note_templates/download/${response.data.token}`;
  return new Promise((resolve, reject) => {
    if (response.data.status === 'ready') {
      resolve(response);
    } else if (response.data.status === 'error') {
      reject(new Error('Promise failed'));
    } else {
      setTimeout(() => {
        try {
          api
            .get(
              url,
              input,
            )
            .then((getResponse) => {
              resolve(
                poll(getResponse, api, input, weddingId, orgId).catch((error) => {
                  return Promise.reject(error);
                }),
              );
            });
        } catch (error) {
          reject(error);
        }
      }, 3000);
    }
  });
};

export { streamDownload };

export const getPublicNote = async ({ id }) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/webhook/nodejs/wedding/note/${id}`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'Authorization': `Bearer ${token}`,
    },
  });

  const response = await api.get();
  return response;
};

export const getPublicTemplate = async ({ id }) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/webhook/nodejs/templates/note/${id}`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'Authorization': `Bearer ${token}`,
    },
  });

  const response = await api.get();
  return response;
};
